if (customElements.get('quick-buy') === undefined) {

  customElements.define('quick-buy', class QuickBuy extends HTMLElement {
    constructor() {
      'use strict';
      super();

      this.processingQuickViewRequest = false;
      this.button = this.querySelector('button');
      this.quickViewTargetId = this.button.dataset.open; // The ID of the modal or drawer to open
      this.quickBuyProductHandle = this.button.dataset.productHandle;
      this.quickBuyType = this.button.dataset.quickBuyType;

      if (this.quickBuyType === 'add') {
        this.button.addEventListener('click', this.quickAddToCart.bind(this));
      } else if (this.quickBuyType === 'quick_view') {
        this.button.addEventListener('click', this.onQuickViewRequest.bind(this));
      }
    }

    async onQuickViewRequest(event) {
      event.preventDefault();
      if (this.processingQuickViewRequest === true) {
        return;
      }

      this.button.classList.add('loading');

      // Check if the view is already exists -> Open it
      // If not, fetch the view and show it
      const currentQuickView = document.getElementById(this.quickViewTargetId);
      if (currentQuickView) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(this.quickViewTargetId);
        this.button.classList.remove('loading');
        return;
      };

      // If the view does not exist, fetch it
      this.processingQuickViewRequest = true;

      // Remove any existing quick views to prevent duplicates
      document.querySelectorAll('[data-quick-view]').forEach((quickView) => {
        quickView.remove();
      });

      const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
      const res = await fetch(`${rootUrl}products/${this.quickBuyProductHandle}?view=quick-view`)
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const quickViewElement = doc.body.firstChild;
      document.body.appendChild(quickViewElement)

      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.quickView = quickViewElement;
      this.hookEvents();

      setTimeout(() => {
        this.button.classList.remove('loading');
        Woolman.ModalsAndDrawers.showModalOrDrawer(this.quickViewTargetId);
      }, 100);
    }

    hookEvents() {
      this.updateOptions();

      this.quickView.querySelector('[data-quick-view-radios]').addEventListener('change', this.onVariantChange.bind(this));
      this.quickView.querySelector('[data-close]').addEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);
      this.quickView.querySelector('[data-overlay]').addEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);

      const productForm = document.getElementById(`product-form-${this.dataset.product}`);
      this.processingQuickViewRequest = false;
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }

    updateOptions() {
      const fieldsets = Array.from(this.quickView.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.product}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (this.quickView.dataset.isPreorder == 'true') {
          addButtonText.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      if (!modifyClass) return;
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=quick-buy-modal`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.product}`);
          const source = html.getElementById(`price-${this.dataset.product}`);

          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(`price-${this.dataset.product}`);

          if (price) price.classList.remove('hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGridySlider = document.getElementById('slider-quick-view');

      if (mediaGridySlider) {
        mediaGridySlider.scrollToSlideByID(
          `item-${this.currentVariant.featured_media.id}`
        );
      }
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.product}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.product}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.quickView.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    async quickAddToCart(event) {
      event.preventDefault();
      const variantId = this.button.dataset.variantId;
      const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };

      this.button.setAttribute('disabled', true);
      this.button.classList.add('loading');

      if (!variantId) {
        console.warn('No variant ID found on the add to cart button');
        return;
      }

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then((data) => {
            this.showTooltip(data.message);
            throw new Error(`Network response was not ok: ${data.message}`);
          });
        } else {
          const event = new CustomEvent('ajaxProduct:added');
          document.dispatchEvent(event);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
      console.log('Adding variant to cart:', variantId);
    }

    showTooltip(message) {
      let tooltip = this.querySelector('.tooltip');
      if (!tooltip) {
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip size--tiny';
        this.appendChild(tooltip);
      }
      tooltip.textContent = message;
      tooltip.style.display = 'block';
      setTimeout(() => {
        tooltip.style.display = 'none';
      }, 3000);
    }
  });

  customElements.define('quick-view-radios', class QuickViewRadios extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(e) {
      this.updateOptions();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      this.updateLegends();
    }

    updateLegends() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((fieldset) => {
        const legend = fieldset.querySelector('legend [data-variant-legend]');
        const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        legend.textContent = selectedOption.getAttribute('value');
      });
    }
  });

}